import { createSwiper } from './swiper';

const initSection = (section) => {
  const carousel = section.querySelector('.blogs__swiper');
  if (!carousel) return;

  let instance = null;

  const destroy = () => {
    if (instance) {
      instance.destroy(true, true);
      instance = null;
    }
  };

  instance = createSwiper(carousel, {
    lazy: true,
    slideClass: 'blogs__card',
    wrapperClass: 'blogs__list',
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    navigation: {
      nextEl: carousel.querySelector('.blogs__nav-btn--next'),
      prevEl: carousel.querySelector('.blogs__nav-btn--prev'),
    },
    a11y: { enabled: true },
  });

  return destroy;
};

const blogs = () => {
  const destroyers = new Map();

  document.querySelectorAll('.blogs').forEach((section) => {
    const destroy = initSection(section);
    if (destroy) destroyers.set(section.id, destroy);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.blogs');
    if (section) {
      const destroy = initSection(section);
      if (destroy) destroyers.set(section.id, destroy);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.blogs');
    if (section && destroyers.has(section.id)) {
      destroyers.get(section.id)();
      destroyers.delete(section.id);
    }
  });
};

export default blogs;
